import { render, staticRenderFns } from "./EpBannerList.vue?vue&type=template&id=8397ecf0&"
import script from "./EpBannerList.vue?vue&type=script&lang=js&"
export * from "./EpBannerList.vue?vue&type=script&lang=js&"
import style0 from "./EpBannerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports